import {
	get,
	post
} from './http'

export default {
	/**
	 * @description 登陆接口
	 * @param {Object} userName 用户名
	 * @param {Object} password 密码
	 */
	Login(userName, password) {
		return post('api/User/Login', {
			userName: userName,
			password: password,
			ip: "",
			device:'web'
		})
	},
	
	GetIndexJobList(token) {
		return get('api/User/GetIndexJobList', {
			token: token,
		})
	},
	
	GetInformationList(token) {
		return get('api/User/GetInformationList', {
			token: token,
		})
	},
	
	GetMeetingList(token) {
		return get('api/User/GetMeetingList', {
			token: token,
		})
	},
	
	GetMyApplyList(token, page = 1, recordCount = 15) {
		return get('api/User/GetMyApplyList', {
			token,
			page,
			recordCount
		})
	},
}



// WEBPACK FOOTER //
// ./src/request/userApi.js